import React from 'react';
import PropTypes from 'prop-types';

const PublicRoutes = ({ component: Component }) => <Component />;

PublicRoutes.propTypes = {
  component: PropTypes.func,
}
export default PublicRoutes;
